import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import * as customerActions from "../../Redux/Actions/customer";
import { toastMessage } from "../../utils/toast";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { validationError, clearSession } from "../../utils/initiate";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AddCustomer = ({ history }) => {
  const [buttonLoading, setButtonLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "Mr.",
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    countryCode: "",
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleAddUser = () => {
    const payload = {
      ...formData,
    };
    setButtonLoading(true);
    if (
      formData.title !== "" &&
      formData.firstName !== "" &&
      formData.lastName !== "" &&
      formData.email !== "" &&
      formData.mobileNumber !== "" &&
      formData.countryCode !== ""
    ) {
      customerActions
        .create(payload)
        .then((res) => {
          if (res && res.data) {
            toastMessage("success", `User added successfully`);
            history.push("/customers");
            setFormData({
              title: "Mr.",
              firstName: "",
              lastName: "",
              email: "",
              mobileNumber: "",
              countryCode: "",
            });
          } else {
            toastMessage("error", `Customer added Failed`);
          }
          setButtonLoading(false);
        })
        .catch((err) => {
          setButtonLoading(false);
          err.response.status === 400 &&
            err.response &&
            validationError(err.response);
          err.response.status === 401 && clearSession(dispatch, history);
        });
    } else {
      setButtonLoading(false);
      toastMessage("error", `Enter the correct customer details`);
    }
  };

  const handlePhoneInput = (e, value) => {
    let splitMobile = e?.split(value?.dialCode);
    handleOnChange("countryCode", value?.dialCode);
    handleOnChange("mobileNumber", splitMobile?.[1]);
  };

  const handleOnChange = (field, value) => {
    setFormData((preState) => ({
      ...preState,
      [field]: value,
    }));
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-xxl-12">
          {loading ? (
            <div className="min-vh-100 d-flex align-items-center justify-content-center">
              <Loader type="ThreeDots" color="#2d207d" height={40} width={40} />
            </div>
          ) : (
            <div className="card border-0 card-stretch">
              <div className="card-header border-0 py-3">
                <h3 className="card-title align-items-start flex-column">
                  <span className="card-label font-weight-bolder text-dark">
                    {t("customersManagement.addCustomer.title")}
                  </span>
                </h3>
              </div>
              <div className="card-body pt-0 pb-3">
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.customerTitle")}
                  </label>
                  <select
                    className="form-select"
                    value={formData.title}
                    name="title"
                    onChange={(e) => {
                      handleOnChange("title", e.target.value);
                    }}
                  >
                    <option className="font-17" value="Mr.">
                      Mr.
                    </option>
                    <option className="font-17" value="Mrs.">
                      Mrs.
                    </option>
                    <option className="font-17" value="Major.">
                      Major.
                    </option>
                    <option className="font-17" value="Dr.">
                      Dr.
                    </option>
                  </select>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.firstName")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.firstNamePlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={formData.firstName}
                    onChange={(e) =>
                      handleOnChange("firstName", e.target.value)
                    }
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.lastName")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.lastNamePlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={formData.lastName}
                    onChange={(e) => handleOnChange("lastName", e.target.value)}
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.email")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.emailPlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={(e) => handleOnChange("email", e.target.value)}
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.mobileNumber")}
                  </label>
                  <PhoneInput
                    country={"ae"}
                    placeholder={t(
                      "customersManagement.addCustomer.mobileNumber"
                    )}
                    onChange={(e, phone) => handlePhoneInput(e, phone)}
                  />
                </div>
                <button
                  disabled={buttonLoading}
                  onClick={handleAddUser}
                  type="button"
                  className="d-flex align-items-center btn btn-primary font-weight-bold mb-2"
                >
                  {t("customersManagement.addCustomer.title")}{" "}
                  {buttonLoading && (
                    <Loader
                      type="Oval"
                      color="#fff"
                      height={20}
                      width={20}
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddCustomer;
